<template>

    <div class="trax-struct-map trax-struct-flat" v-show="loaded">
        <div :id="id+'-struct'" class="trax-struct-body">
            <div class="trax-block trax-level-1" v-for="section in sections" :key="section.id" :data-id="section.id"
                 v-if="hasUnits(section)">

                <h3 v-if="sections.length>1">{{ section.name }}</h3>

                <div class="clearfix"></div>

                <div :id="id+'-struct-'+section.id" class="trax-block-body" :data-id="section.id">

                    <div class="card" v-for="learning_unit in section.learning_units" :key="learning_unit.id" v-if="programUnit(learning_unit) && missingSignature(learning_unit)">
                        <div class="card-body">

                            <enac-atpl-dashboard-phase-map-item
                                :id="id" :bus="bus" :item="learning_unit" :states="states">
                            </enac-atpl-dashboard-phase-map-item>

                            <div class="row">
                                <div class="col-xl-7 pb-0 trax-name">
                                    <h4>{{ learning_unit.name }}</h4>
                                </div>
                                <div class="col-xl-5" v-html="itemSignatures(learning_unit)"></div>
                            </div>
                        </div>
                    </div>

                    <div class="trax-btn-square trax-icon" v-if="hasGroupUnits(section)">
                        + <i class="material-icons">people_outline</i>
                    </div>

                    <div class="card" v-for="learning_unit in section.learning_units" :key="learning_unit.id" v-if="groupUnit(learning_unit) && missingSignature(learning_unit)">
                        <div class="card-body">

                            <enac-atpl-dashboard-phase-map-item
                                :id="id" :bus="bus" :item="learning_unit" :states="states">
                            </enac-atpl-dashboard-phase-map-item>

                            <div class="row">
                                <div class="col-xl-7 pb-0 trax-name">
                                    <h4>{{ learning_unit.name }}</h4>
                                </div>
                                <div class="col-xl-5" v-html="itemSignatures(learning_unit)"></div>
                            </div>
                        </div>
                    </div>

                    <div class="trax-btn-square trax-icon" v-if="hasUserUnits(section)">
                        + <i class="material-icons">person_outline</i>
                    </div>

                    <div class="card" v-for="learning_unit in section.learning_units" :key="learning_unit.id" v-if="userUnit(learning_unit) && missingSignature(learning_unit)">
                        <div class="card-body">

                            <enac-atpl-dashboard-phase-map-item
                                :id="id" :bus="bus" :item="learning_unit" :states="states">
                            </enac-atpl-dashboard-phase-map-item>

                            <div class="row">
                                <div class="col-xl-7 pb-0 trax-name">
                                    <h4>{{ learning_unit.name }}</h4>
                                </div>
                                <div class="col-xl-5" v-html="itemSignatures(learning_unit)"></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {

        props: {
            id: null,
            bus: null
        },

        data: function() {
            return {
                lang: lang,
                loaded: false,
                user: user,
                learner: data.learner,
                endpoint: app_url+'polaris/api/front/sections',
                endpointParams: {
                    options: {
                        registration: data.registration.id,
                        all_users: true
                    },
                    filters: {
                        phase_id: data.phase.id
                    },
                    sort: ['order']
                },
                endpoint_states: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/phases/'+data.phase.id+'/unsigned',
                url_base: app_url+'polaris/ui/atpl-dashboard/registration/'+data.registration.id+'/',
                sections: [],
                states : {}
            }
        },

        created: function() {
            this.getData();
            this.getStates();
        },

        methods: {

            programUnit(learning_unit) {
                return !learning_unit.registration_id;
            },

            groupUnit(learning_unit) {
                return learning_unit.registration_id && !learning_unit.user_id;
            },

            userUnit(learning_unit) {
                return learning_unit.user_id;
            },

            hasUnits(section) {
                return section.learning_units && (this.hasProgramUnits(section) || this.hasGroupUnits(section) || this.hasUserUnits(section));
            },

            hasProgramUnits(section) {
                for (var index in section.learning_units) {
                    var learning_unit = section.learning_units[index];
                    if (this.programUnit(learning_unit)) {
                        if (this.missingSignature(learning_unit)) return true;
                    }
                }
                return false;
            },

            hasGroupUnits(section) {
                for (var index in section.learning_units) {
                    var learning_unit = section.learning_units[index];
                    if (this.groupUnit(learning_unit)) {
                        if (this.missingSignature(learning_unit)) return true;
                    }
                }
                return false;
            },

            hasUserUnits(section) {
                for (var index in section.learning_units) {
                    var learning_unit = section.learning_units[index];
                    if (this.userUnit(learning_unit)) {
                        if (this.missingSignature(learning_unit)) return true;
                    }
                }
                return false;
            },

            getData() {
                var that = this;
                axios.get(that.endpoint, {params: that.endpointParams})
                    .then(function (response) {
                        that.sections = response.data.data;
                        that.loaded = true;
                    })
                    .catch(function (error) {
                    });
            },

            getStates() {
                var that = this;
                axios.get(this.endpoint_states)
                    .then(function (response) {
                        that.states = Array.isArray(response.data.data) ? {} : response.data.data;
                    })
                    .catch(function (error) {
                    });
            },
            
            itemSignatures(learning_unit) {
                if (!this.states[learning_unit.id]) return '';
                var state = this.states[learning_unit.id];
                if (!state.unsigned_users) return '';
                var html = '';

                for (var index in state.unsigned_users) {
                    html += this.unvalidatedHtml(state.unsigned_users[index]);
                }
                return html;
            },

            missingSignature(learning_unit) {
                if (!this.states[learning_unit.id]) return false;
                var state = this.states[learning_unit.id];
                return state.unsigned_users && state.unsigned_users.length > 0;
            },

            unvalidatedHtml(username, newLine) {
                if (!username) return '';
                var html = '';
                html += '<small class="text-danger">';
                html += '   <i class="material-icons text-danger" style="position:relative !important;top:3px !important;">error_outline</i> ';
                html += username;
                html += '</small><br>';
                return html;
            },
        }
    }
</script>
